import { z } from "zod";

import { rotationParametersSchema } from "./rotation-parameters";
import { addLabelConfigurationSchema } from "./add-label-configuration";

export const addCartonConfigurationSchema = z.object({
	labels: z.array(addLabelConfigurationSchema).optional(),
	designId: z.string().nullish(),
	designIdAttribute: z.string().optional(),
	optimalRotation: z.boolean().optional(),
	rotationParameters: rotationParametersSchema.optional(),
	qualityExpression: z.string().optional(),
	fluteExpression: z.string().optional(),
	contentExpressions: z.array(z.string()).optional(),
	lengthExpression: z.string().optional(),
	widthExpression: z.string().optional(),
	heightExpression: z.string().optional(),
	xValueExpressions: z.record(z.string(), z.string()).optional(),
	barcodeExpression: z.string().optional(),
});
export type AddCartonConfiguration = z.infer<typeof addCartonConfigurationSchema>;
